import { NavigationOptions, RouterSimpleState } from '@neptune/shared/routing-domain';

import { storage } from 'common/storage';

const RUN_DETAILS_ORIGIN_ROUTE_STORAGE_KEY = 'runDetailsOriginRoute';

export function persistRunDetailsOriginRoute(
  { name, params }: RouterSimpleState,
  options: NavigationOptions = {},
) {
  storage.session.setItem(RUN_DETAILS_ORIGIN_ROUTE_STORAGE_KEY, { name, params, options });
}

export function getRunDetailsOriginRoute(): (RouterSimpleState & NavigationOptions) | undefined {
  return storage.session.getItem(RUN_DETAILS_ORIGIN_ROUTE_STORAGE_KEY);
}
